var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.26 5.9049V4.1349C11.26 2.0625 9.57504 0.375 7.49994 0.375C5.42754 0.375 3.74004 2.0625 3.74004 4.13505V5.90505C2.87244 5.9775 2.18994 6.7098 2.18994 7.5948V9.705C2.18994 12.4174 4.39494 14.625 7.10739 14.625H7.89249C10.6049 14.625 12.8099 12.4174 12.8099 9.705V7.59495C12.8099 6.70995 12.1276 5.9775 11.26 5.9049ZM5.36754 4.1349C5.48439 1.30935 9.51564 1.3101 9.63249 4.1349V5.89755H5.36754V4.1349ZM6.90504 10.4576C6.02754 9.88515 6.45564 8.4858 7.50009 8.4951C8.54439 8.48625 8.97309 9.8844 8.09499 10.4576C8.02749 10.5026 7.98504 10.5827 7.98504 10.6651V11.5427C7.96884 12.1813 7.03194 12.1827 7.01499 11.5427V10.665C7.01499 10.5825 6.97254 10.5026 6.90504 10.4576Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a03da01c0cc53051862e17bacbb88af1.svg";
export { ForwardRef as ReactComponent };